export default {
  CareQuilt: 'CareQuilt',
  NotFound: 'CareQuilt - Profile not found',
  Profile: {
    Title: 'CareQuilt - #{firstName} #{lastName}',
    description: 'Meet #{firstName} #{lastName}, one of our dedicated caregivers. #{firstName} #{lastName} says, #{shortBio}',
  },
};
